// extracted by mini-css-extract-plugin
module.exports = {"header":"_2-pbk","headerContainer":"_2NVvn","headerBackground":"_2uEuc","logoContainer":"mJS5n","logo":"_3DVLz","logoImg":"_3ntiB","rightContainer":"_2Oh09","socialLinks":"_3rb4J"};